import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Menu } from '../model/menu.model';
import { environment } from '../../../../environments/environment'; // Adjust path as needed

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  private apiUrl = `${environment.SERVER_API_URL}api/menus`; // Correct URL

  constructor(private http: HttpClient) {}

  private getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem('authToken');
    return new HttpHeaders({
      'Authorization': `Bearer ${token || ''}`,
      'x-client-offset': '-330',
      'x-tenantid': 'your-tenant-id' // Replace with actual tenant ID
    });
  }

  getAllMenus(): Observable<Menu[]> {
    return this.http.get<Menu[]>(this.apiUrl, { headers: this.getAuthHeaders() })
      .pipe(catchError(this.handleError));
  }

  getMenuById(id: number): Observable<Menu> {
    return this.http.get<Menu>(`${this.apiUrl}/${id}`, { headers: this.getAuthHeaders() })
      .pipe(catchError(this.handleError));
  }

  createMenu(menu: Menu): Observable<Menu> {
    return this.http.post<Menu>(this.apiUrl, menu, { headers: this.getAuthHeaders() })
      .pipe(catchError(this.handleError));
  }

  updateMenu(id: number, menu: Menu): Observable<Menu> {
    return this.http.put<Menu>(`${this.apiUrl}/${id}`, menu, { headers: this.getAuthHeaders() })
      .pipe(catchError(this.handleError));
  }

  deleteMenu(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`, { headers: this.getAuthHeaders() })
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    console.error('API Error:', error);
    if (error.status === 401) {
      console.log('Unauthorized: Check token or tenant ID');
    }
    return throwError(() => new Error('Something went wrong; please try again later.'));
  }
}